import { render } from "./HeroiconsOutlineTemplate.vue?vue&type=template&id=a0081f5c"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTemplate.vue"]])

export default __exports__